$('.logo-bar').owlCarousel({
    loop: true,
    margin: 20,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 1,
    smartSpeed: 5000,
    slideTransition: 'linear',
    autoplayHoverPause: false,

    responsive: {
        0: { items: 2 },
        480: { items: 3 },
        768: { items: 4 },
        1200: { items: 5 }
    }
});